module.exports = {

  init() {

    lozad().observe();
    
    this.cookie()
    
    this.featuredCarousel();
    
    this.menuBold();
    
    this.mobileMenuToggle();
    

  },
  
  cookie() {
	  $(document).ready(function(){
	    $.cookieBar({
			message: 'By using this website you agree to our use of cookies.',
			acceptText: 'Got it',
			fixed: true,
			policyButton: true,
			policyText: 'Find out more',
			policyURL: '/privacy-policy/#Cookies'
		});
	  });  
	
  },
  
  featuredCarousel: function() {

		 
		 $('.owl-carousel').owlCarousel({
		    loop:true,
		    margin:32,
		    responsiveClass:true,
		    navText: [ , ],
		    autoplay:true,
		    responsive:{
		        0:{
		            items:1,
		            nav:true
		        },
		        600:{
		            items:2,
		            nav:true
		        }
		        
		    }
		})
  },
  
  menuBold: function() {
	  	 
    $('.last-bold a').each(function(){
       var $t = $(this);
       $t.html($t.text().trim().replace(/(\w+)[.!?]?\s*$/, "<span>$1</span>"));
    });
	  
  },  

  
  mobileMenuToggle: function() {
	  
	  function myfunction() {

		  var width = $(window).width();
		  
/*
		  if(width < 992){  			  
			
			$('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
				$(this).next('.dropdown-menu').toggleClass('show');	
			});
			
			$('.menu-item-has-children a.dropdown-toggle[href!="#"] span').on('click', function(e) { 	
				e.preventDefault(); 
				$(this).parent().next('.dropdown-menu').toggleClass('show');	
			});
			
		  } else {
			  
			  $('.menu-item-has-children .dropdown-menu').removeClass('show');
			  
			  $('.menu-item-has-children a.dropdown-toggle[href="#"]').on('click', function(e) {  	
				e.preventDefault(); 
			  });
			  
		  }
*/
	  }
	  
	  $(document).ready(myfunction);
	  $(window).on('resize',myfunction);
  },

}
